import {
  createRootRoute,
  createRoute,
  createRouter,
  lazyRouteComponent,
  Outlet,
  useRouterState,
} from "@tanstack/react-router";
import { RouteFocus } from "@clones/ui";
import { AppShell } from "@/components/app-shell";
function RootContent() {
  const path = useRouterState({ select: (s) => s.location.pathname });
  const settled = useRouterState({
    select: (s) => !s.isLoading && s.status === "idle",
  });
  return (
    <>
      <RouteFocus pathname={path} settled={settled} />
      <Outlet />
    </>
  );
}
const root = createRootRoute({
  component: RootContent,
  notFoundComponent: () => (
    <div className="studio-auth">
      <p>
        Страница не найдена.{" "}
        <a href="/" className="underline">
          Открыть задачи
        </a>
      </p>
    </div>
  ),
});
const login = createRoute({
  getParentRoute: () => root,
  path: "/login",
  component: lazyRouteComponent(() => import("@/pages/login"), "LoginPage"),
  validateSearch: (search: Record<string, unknown>) => ({
    redirect:
      typeof search["redirect"] === "string" ? search["redirect"] : undefined,
  }),
});
const mfa = createRoute({
  getParentRoute: () => root,
  path: "/mfa",
  component: lazyRouteComponent(() => import("@/pages/mfa"), "MfaPage"),
});
const enroll = createRoute({
  getParentRoute: () => root,
  path: "/enroll",
  component: lazyRouteComponent(() => import("@/pages/enroll"), "EnrollPage"),
});
const register = createRoute({
  getParentRoute: () => root,
  path: "/register/$inviteToken",
  component: lazyRouteComponent(
    () => import("@/pages/register"),
    "RegisterPage",
  ),
});
const survey = createRoute({
  getParentRoute: () => root,
  path: "/survey",
  component: lazyRouteComponent(() => import("@/pages/survey"), "SurveyPage"),
});
const workspace = createRoute({
  getParentRoute: () => root,
  id: "_workspace",
  component: AppShell,
});
const tasks = createRoute({
  getParentRoute: () => workspace,
  path: "/",
  component: lazyRouteComponent(() => import("@/pages/tasks"), "TasksPage"),
});
const detail = createRoute({
  getParentRoute: () => workspace,
  path: "/tasks/$taskId",
  component: lazyRouteComponent(
    () => import("@/pages/task-detail"),
    "TaskDetailPage",
  ),
});
const profile = createRoute({
  getParentRoute: () => workspace,
  path: "/profile",
  component: lazyRouteComponent(() => import("@/pages/profile"), "ProfilePage"),
});
export const router = createRouter({
  routeTree: root.addChildren([
    login,
    mfa,
    enroll,
    register,
    survey,
    workspace.addChildren([tasks, detail, profile]),
  ]),
  defaultPreload: "intent",
});
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
